<template>
  <h2>Pots Page</h2>
</template>

<script>
export default {

}
</script>

<style>

</style>